module.exports = __webpack_public_path__ + "static/assets/23258c89260212366a02005f1b4deadb.png";